import React, { Component } from 'react'
import { Menu, Icon, Dropdown, Image, Label } from 'semantic-ui-react'
import { Link, NavLink } from 'react-router-dom'
// redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { logoutUser } from '../actions/user'
import { toggleCart } from '../actions/ui'
import freedom from '../images/freedom-wings.svg'

class Navbar extends Component {
  render() {
    const { user } = this.props
    const { isLoggedIn, detail } = user
    const { firstname, role } = detail
    const isAdmin = role === 'admin'
    const userDropdown = (
      <div>
        <Icon name="user outline" /> {firstname}
      </div>
    )
    const { cart, cartSum } = this.props.product
    if (!isLoggedIn) {
      return null
    }
    return (
      <Menu
        size="large"
        style={{ marginBottom: 0 }}
        fixed="top"
        borderless
        className="no-print"
        inverted
      >
        <Menu.Item as={Link} to="/" style={{ paddingTop: 5, paddingBottom: 5 }}>
          <Image src={freedom} width={30} />
        </Menu.Item>
        {isLoggedIn
          ? <Menu.Menu position="right">
              {isAdmin
                ? <Menu.Item as={NavLink} to="/admin/dashboard">
                    Admin
                  </Menu.Item>
                : null}

              {role === 'approver' || role === 'admin'
                ? <Menu.Item as={NavLink} to="/approver">
                    Approver{' '}
                    {this.props.product.approverOrders.length > 0
                      ? <Label color="blue" empty circular size="mini" />
                      : null}
                  </Menu.Item>
                : null}

              <Menu.Item as={NavLink} to="/view-orders">
                My Orders
              </Menu.Item>
              <Menu.Item onClick={this.props.toggleCart} as="a">
                <Icon.Group size="large">
                  <div className="icon-bag" />
                  {cart.length > 0
                    ? <Icon corner name="circle" color="blue" />
                    : null}
                </Icon.Group>
                {cart.length ? cartSum : null}
              </Menu.Item>
              <Dropdown text={userDropdown} pointing className="link item">
                <Dropdown.Menu>
                  <Dropdown.Item as={NavLink} to="/password-reset">
                    Password Reset
                  </Dropdown.Item>
                  <Dropdown.Item onClick={this.props.logoutUser}>
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Menu.Menu>
          : <Menu.Menu position="right">
              <Menu.Item as={Link} to="/login">
                Login
              </Menu.Item>
            </Menu.Menu>}
      </Menu>
    )
  }
}

const mapStateToProps = state => {
  return state
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      logoutUser,
      toggleCart
    },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Navbar)



// WEBPACK FOOTER //
// ./src/components/Navbar.jsx